export enum PhoneNumberValidationMethod {
    SmsCode = 'SmsCode',
    Whitelisted = 'Whitelisted',
    RegexOnly = 'RegexOnly',
    UnableToVerifyAtCreation = 'UnableToVerifyAtCreation',
}
